import React from 'react'
import styled from 'styled-components'
import { Flex, Box } from 'reflexbox/styled-components'
import startCase from 'lodash/startCase'
import kebabCase from 'lodash/kebabCase'
import { renderIcon as renderIndustryIcon } from '@anvilco-pkg/ui/components/Icon/industries'

import media from 'media'
import theme from 'theme'

import Button from 'components/Button'

const SolutionsButton = styled(Button).attrs({})`
  margin-top: 20px;

  ${media.tablet`
    width: fit-content;
  `}

  ${media.desktop`
    margin-top: 0;
  `}
`

const SolutionsContainer = styled(Box)
  .attrs({
    py: [24],
    px: [20, 30],
    width: ['100vw', 1],
    ml: [-20, 0],
  })
  .withConfig({
    shouldForwardProp: (prop) => ['noCarouselNodes'].indexOf(prop) === -1,
  })`
background: ${theme.colors.blues[10]};
  display: flex;
  flex-direction: column;

  ${media.tablet`
    flex-direction: row;
  `}
`

const SolutionsIconContainer = styled(Flex).attrs({
  justifyContent: 'center',
  alignItems: ['flex-start', 'flex-start', 'center'],
  mr: [24],
  mt: [0, 10, 0],
})`
  display: none;

  svg {
    min-width: 55px;
    height: auto;
  }

  ${media.tablet`
    display: flex;
  `}
`

const SolutionsFlexContainer = styled(Flex).attrs({
  flexDirection: ['column', 'column', 'row'],
  alignItems: ['flex-start', 'flex-start', 'center'],
  mb: [20, 0],
})``

const SolutionsContent = styled(Box).attrs({
  mr: [30],
})`
  strong {
    font-size: 18px;
    margin-bottom: 8px;
    display: inline-block;
  }

  ${media.tablet`
    strong {
      margin-bottom: unset;
    }
  `}
`

const getCompanyType = (tag) => {
  switch (tag) {
    case 'Taxes':
      return 'tax'
    case 'Employment':
      return 'human resources'
    default:
      return tag.toLowerCase()
  }
}

const getSolutionsSlug = (tag) => {
  switch (tag) {
    case 'Employment':
      return 'human-resources'
    case 'Taxes':
      return 'finance'
    default:
      return kebabCase(tag.toLowerCase())
  }
}

const HAS_SOLUTIONS_PAGE = [
  'Taxes',
  'Employment',
  'Finance',
  'Real Estate',
  'Healthcare',
  'Insurance',
]

export function SolutionsCTA ({ tag, renderTitle, ...others }) {
  return (
    HAS_SOLUTIONS_PAGE.find(
      (item) => item?.toLowerCase() === tag?.toLowerCase()
    ) && (
      <SolutionsContainer {...others}>
        <SolutionsIconContainer>
          {renderIndustryIcon(`Icon${startCase(tag)?.replaceAll(' ', '')}`, {
            fill: theme.colors.blues[30],
          })}
        </SolutionsIconContainer>
        <SolutionsFlexContainer>
          <SolutionsContent>
            <strong>{renderTitle(getCompanyType(tag))}</strong>
            <div>
              Learn how {getCompanyType(tag)} companies use Anvil's document
              APIs to launch digital products
            </div>
          </SolutionsContent>
          <SolutionsButton
            type="cta"
            chevron={{ position: 'inner', direction: 'right' }}
            size="large"
            to={`/solutions/${getSolutionsSlug(tag)}/`}
          >
            Explore solutions
          </SolutionsButton>{' '}
        </SolutionsFlexContainer>
      </SolutionsContainer>
    )
  )
}

SolutionsCTA.defaultProps = {
  renderTitle: (tag) => `How Anvil helps ${tag} companies`,
}
